<template>
  <div class="animated fadeIn plan-and-approve-container">
    <EventStatusSelection ></EventStatusSelection>
    
    <div class="table-event-container margin-side">
      <TableHeader></TableHeader>
      <div id="dt-body" :style="{'padding-top': fixElement ? '55px': 0}">
        <template v-for="(item, index) in getListEvent">
          <EventRow class="event-row-wrapper" :item="item" :index="index" :key="item"></EventRow>
        </template>
      </div>
    </div>
    <div :class="{'isLoading': getLoading, 'noDisplay': !getLoading}">
      <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
    </div>
  </div>
</template>

<script>
// import nav from '../../_nav';
import EventStatusSelection from '../../components/commons/EventStatusSelection';
import EventRow from '../../components/datatable/EventRow';
import consts from '../../_consts';
import {mapGetters} from 'vuex';
import TableHeader from '@/components/datatable/TableHeader';

/* Register component with one of 2 methods */
import 'vue-awesome/icons/spinner';
import Icon from 'vue-awesome/components/Icon';

export default {
  name: 'plan-and-approve',
  components: {
    EventStatusSelection,
    EventRow,
    Icon,
    TableHeader
  },
  computed: {
    getHeightOfComp () {
      return 127;
    },
    ...mapGetters({
      getListEvent: 'GETTERS_LIST_EVENT',
      getLoading: 'GETTERS_IS_LOADING'
    })
  },
  data () {
    return {
      fixElement: false
    }
  },
  methods: {
    handleScroll () {
      this.fixElement = window.scrollY >= 180;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', consts.viewNames.planAndApprove);
  }
};
</script>


<style lang="less">
  @import "../../styles/variables.less";

  .isLoading {
    display: block;
    text-align: center;
    color: @grey-1;
  }
  .noDisplay {
    display: none;
  }
  .event-row-wrapper{
    margin: 8px 0px;
  }
  .fix-element-to-top{
  }
  .icon-size {
    width: 100px;
    height: 100px;
  }

  .plan-and-approve-container{
    .table-event-container{
      background-color: @grey-5;
      overflow: auto;

      .dt-body{
      }

      .fix-position-top{
        transition: all 0.7s;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PlanAndApprove.vue?25900b53